<template>
  <div class="overview-page">
    <h2 class="overview-title">总览</h2>
    <div class="overview-item" v-if="financeData.IsShowSaleModule">
      <h3 class="overview-item-hd">销售信息总览</h3>
      <div class="year-dropdown">
        <div class="year el-dropdown-link">{{salesYear}} <i class="arrow"></i></div>
        <el-select v-model="salesYear" size="mini" @change="loadSalesData">
          <el-option v-for="(item,index) in years" :key="index" :label="item" :value="item" :selected="item==salesYear">{{item}}</el-option>
        </el-select>
      </div>
      <ul class="info">
        <li class="info-item">
          <span class="count" @click="$router.push('/center/myCustomer')">{{salesData.ActiveKaCount || 0}}</span>
          <div class="desc">有效注册客户/家</div>
        </li>
        <li class="info-item">
          <span class="count" @click="$router.push('/center/myCustomer')">{{salesData.PastDueKaCount || 0}}</span>
          <div class="desc">过期注册客户/家</div>
        </li>
        <li class="info-item">
          <span class="count" @click="$router.push('/center/customerOrder')">{{salesData.CompleteJobKaCount || 0}}</span>
          <div class="desc">成单客户数/家</div>
        </li>
        <li class="info-item" @click="$router.push('/center/customerOrder')">
          <span class="count">{{salesData.CompleteJobCount || 0}}</span>
          <div class="desc">完成工单数/单</div>
        </li>
        <li class="info-item">
          <span class="count" @click="$router.push('/center/customerOrder')">￥{{salesData.CompleteJobTotalAmount | formatPrice}}</span>
          <div class="tax">含税￥{{salesData.CompleteJobTaxTotalAmount | formatPrice}}</div>
          <div class="desc">成单总金额</div>
        </li>
        <li class="info-item">
          <span class="count price" @click="$router.push('/center/activity')">￥{{salesData.ActivityTotalAmount | formatPrice}}</span>
          <div class="desc">累计活动奖励</div>
        </li>
      </ul>
    </div>
    <div class="overview-item" v-if="financeData.IsShowPickJobModule">
      <h3 class="overview-item-hd">接单信息总览</h3>
      <div class="year-dropdown">
        <div class="year el-dropdown-link">{{receiveYear}} <i class="arrow"></i></div>
        <el-select v-model="receiveYear" size="mini" @change="loadReceiveData">
          <el-option v-for="(item,index) in years" :key="index" :label="item" :value="item" :selected="item==receiveYear">{{item}}</el-option>
        </el-select>
      </div>
      <ul class="info">
        <li class="info-item">
          <span class="count" @click="toPickedOrder">{{receiveData.PickJobCount || 0}}</span>
          <div class="desc">总承接工单/单</div>
        </li>
        <li class="info-item">
          <span class="count" @click="toPickedOrder">{{receiveData.WorkingJobCount || 0}}</span>
          <div class="desc">服务中工单/单</div>
        </li>
        <li class="info-item">
          <span class="count" @click="toPickedOrder">{{receiveData.CompleteJobCount || 0}}</span>
          <div class="desc">已完成工单/单</div>
        </li>
        <li class="info-item">
          <span class="count" @click="toPickedOrder">{{receiveData.PickJobScore || 0}}</span>
          <div class="desc">接单总评分</div>
        </li>
        <li class="info-item">
          <span class="count">￥{{receiveData.CompleteJobAmount | formatPrice}}</span>
          <div class="tax">含税￥{{receiveData.CompleteJobTaxAmount | formatPrice}}</div>
          <div class="desc">成单总金额</div>
        </li>
        <li class="info-item">
          <span @click="$router.push('/orderList')" class="btn-link">去接单</span>
        </li>
      </ul>
    </div>
    <div class="overview-item" v-if="financeData.IsShowSendJobModule">
      <h3 class="overview-item-hd">发单信息总览</h3>
      <div class="year-dropdown">
        <div class="year el-dropdown-link">{{sendYear}} <i class="arrow"></i></div>
        <el-select v-model="sendYear" size="mini" @change="loadSendData">
          <el-option v-for="(item,index) in years" :key="index" :label="item" :value="item" :selected="item==sendYear">{{item}}</el-option>
        </el-select>
      </div>
      <ul class="info">
        <li class="info-item">
          <span class="count" @click="$router.push('/center/createdOrder')">{{sendData.SendJobCount || 0}}</span>
          <div class="desc">总发单数/单</div>
        </li>
        <li class="info-item">
          <span class="count" @click="$router.push('/center/createdOrder')">{{sendData.WorkingJobCount || 0}}</span>
          <div class="desc">服务中工单/单</div>
        </li>
        <li class="info-item">
          <span class="count" @click="$router.push('/center/createdOrder')">{{sendData.CompleteJobCount || 0}}</span>
          <div class="desc">已完成工单/单</div>
        </li>
        <li class="info-item">
          <span class="count" @click="$router.push('/center/createdOrder')">{{sendData.PickJobScore || 0}}</span>
          <div class="desc">发单总评分</div>
        </li>
        <li class="info-item">
          <span class="count" @click="$router.push('/center/createdOrder')">￥{{sendData.CompleteJobAmount | formatPrice}}</span>
          <div class="tax">含税￥{{sendData.CompleteJobTaxAmount | formatPrice}}</div>
          <div class="desc">成单总金额</div>
        </li>
        <li class="info-item">
          <span @click="createOrder" class="btn-link">发布工单</span>
        </li>
      </ul>
    </div>
    <div class="overview-item">
      <h3 class="overview-item-hd">财务信息总览</h3>
      <ul class="info">
        <li class="info-item col4">
          <span class="count price">￥{{financeData.UserMpValue | formatPrice}}</span>
          <div class="desc">账户余额</div>
        </li>
        <li class="info-item col4">
          <span class="count price">￥{{financeData.UserCommission | formatPrice}}</span>
          <div class="desc">账户佣金</div>
        </li>
        <li class="info-item col4">
          <span class="count">{{financeData.WaitInvoiceJobCount || 0}}</span>
          <div class="desc">可开票工单/订单</div>
        </li>
      </ul>
    </div>
    <div class="overview-item" v-if="financeData.IsShowEngineerAuthModule">
      <h3 class="overview-item-hd">工程师认证</h3>
      <div class="model-wrap">
        <div class="model-name">完善工程师资料即可申请成为速派工程师，承接海量工单哦</div>
        <div class="fr">
          <span class="btn-auth" @click="toAuth">去认证</span>
        </div>
      </div>
    </div>
    <order-type :show="isShowCreateDialog" @choose="toCreateOrder" @close="isShowCreateDialog=false"></order-type>
  </div>
</template>
<script>
import {
  GetUserSaleData,
  GetUserPickJobData,
  GetUserSendJobData,
  GetUserFinanceDataAndPermission
} from '@/scripts/api.js'
import {p_origin} from '@/scripts/util.js'
import {bpoAppQrcode} from '@/scripts/bpo.js'
import {mapState,mapGetters} from 'vuex'
import OrderType from '@/components/orderType.vue'
let Year=new Date().getFullYear();
export default {
  components:{
    OrderType
  },
  data(){
    return{
      salesData:{},
      salesYear:Year,
      receiveData:{},
      receiveYear:Year,
      sendData:{},
      sendYear:Year,
      financeData:{
        IsShowSaleModule:false,
        IsShowPickJobModule:false,
        IsShowSendJobModule:false,
        IsShowEngineerAuthModule:false
      },
      isShowCreateDialog:false,
    }
  },
  computed: {
    years(){
      let year=new Date().getFullYear();
      let arr=[];
      for(let i=year;i>=2000;i--){
        arr.push(i);
      }
      return arr;
    },
    userId(){
      if(this.$store.state.userInfo){
        return this.$store.state.userInfo.LoginAccountId;
      }
      return '';
    },
    ...mapState({
      userInfo:state=>state.userInfo,
    }),
    ...mapGetters({
      createTypes: "createTypes",
    }),
  },
  created(){
    this.init();
  },
  methods:{
    init(){
      this.loadSalesData();
      this.loadReceiveData();
      this.loadSendData();
      this.loadFinanceData();
    },
    //销售数据
    loadSalesData(){
      GetUserSaleData({
        userId:this.userInfo.LoginAccountId,
        year:this.salesYear,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1){
          this.salesData=r.Data || {};
        }
      })
    },
    // 接单数据
    loadReceiveData(){
      GetUserPickJobData({
        userId:this.userInfo.LoginAccountId,
        year:this.receiveYear,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1){
          this.receiveData=r.Data || {};
        }
      })
    },
    // 发单数据
    loadSendData(){
      GetUserSendJobData({
        userId:this.userInfo.LoginAccountId,
        year:this.sendYear,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1){
          this.sendData=r.Data || {};
        }
      })
    },
    // 财务数据
    loadFinanceData(){
      GetUserFinanceDataAndPermission({
        userId:this.userInfo.LoginAccountId,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1){
          this.financeData=r.Data || {};
        }
      })
    },
    //查看承接工单
    toPickedOrder(){
      if(this.userInfo.IsHasPickJobPermission){
        this.$router.push('/center/undertakeOrder');
      }else{
        this.$router.push('/orderList');
      }
      
    },
    toAuth(){
      bpoAppQrcode();
    },
    
    //快速发单
    createOrder(){
      if(this.createTypes.length==0){
        this.$toast('您没有发单权限，请联系速派客服');
        return;
      }else if(this.createTypes.length==1){
        this.$router.push({
          path:'/createStep1',
          query:{
            jobType:this.createTypes[0].jobType
          }
        })
      }else{
        this.isShowCreateDialog=true;
      }
    },
    //选择发单类型
    toCreateOrder(item){
      this.$router.push({
        path:'/createStep1',
        query:{
          jobType:item.jobType
        }
      })
      this.isShowCreateDialog=false;
    },
  }
}
</script>
<style lang="scss">
.overview-page{
  .overview-title{
    font-size: 18px;
    line-height: 24px;
    color: #f75959;
    margin-bottom: 20px;
    &:before{
      content:'';
      display: inline-block;
      width: 2px;
      height: 20px;
      background-color: #f75959;
      vertical-align: middle;
      margin-top: -3px;
      margin-right: 16px;
    }
  }
  .overview-item{
    background-color:#F9F9F9;
    border:1px solid #E5E5E5;
    padding:10px 14px 30px;
    position: relative;
    margin-bottom: 20px;
    .overview-item-hd{
      font-size: 14px;
      color: #333;
      line-height: 20px;
      margin-bottom: 20px;
    }
    
  }
  .year-dropdown{
    position: absolute;
    right: 14px;
    top: 10px;
    z-index: 2;
    .year{
      font-size: 14px;
      color: #333;
      height: 20px;
      line-height: 20px;
      cursor: pointer;
      padding-right: 20px;
      position: relative;
      .arrow{
        position: absolute;
        top: 50%;
        right: 1px;
        width: 0;
        height: 0;
        border: 6px solid transparent;
        border-top: 7px solid #333;
        margin-top: -5px;
      }
    }
    .el-select{
      position: absolute;
      left: 0px;
      top: 0px;
      opacity:0;
    }
  }
  .info{
    overflow: hidden;
    .info-item{
      float: left;
      width: 160px;
      text-align: center;
      &.col4{
        margin-right: 160px;
      }
    }
    .count{
      font-size: 20px;
      color: #333;
      line-height: 24px;
      font-family:"arial","Microsoft Yahei";
      cursor: pointer;
      padding-left: 5px;
      padding-right: 5px;
    }
    .desc{
      font-size: 12px;
      color: #999;
      line-height: 18px;
      margin-top: 18px;
    }
    .tax{
      font-size: 12px;
      color: #666;
      line-height: 18px;
    }
    .tax+.desc{
      margin-top: 0;
    }
    .btn-link{
      display:block;
      width:100px;
      height:30px;
      line-height: 30px;
      text-align:center;
      color:#fff;
      font-size: 12px;
      background-color:#f75959;
      margin-top: 15px;
      float: right;
      cursor: pointer;
    }
  }
  .table-wrap{
    overflow: hidden;
    margin-bottom: 20px;
    .table-left{
      width: 66%;
      float: left;
      border-collapse: collapse;
    }
    .table-right{
      width: 32%;
      float: right;
      border-collapse: collapse;
    }
    th{
      font-size: 14px;
      color: #333;
      height: 48px;
      line-height: 48px;
      background-color: #f8f8f8;
      text-align: center;
      border: 1px solid #e5e5e5;
      font-weight: normal;
    }
    td{
      font-size: 14px;
      color: #666;
      height: 48px;
      line-height: 48px;
      text-align: center;
      border: 1px solid #e5e5e5;
    }
  }
  .model-wrap{
    overflow: hidden;
    .model-name{
      float: left;
      font-size: 12px;
      color: #999;
      line-height: 30px;
    }
    .fr{
      float: right;
    }
    .btn-auth{
      background-color: #f75959;
      color:#fff;
      font-size:12px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      display: inline-block;
      vertical-align: middle;
      width:100px;
      cursor: pointer;
    }
  }
  .price{
    color: #f75959 !important;
  }
}
</style>